// SignUpStep1.js
import { Box } from "@mui/material";
import MainContentReUse from "./MainContentReUse";
import TextFieldWithHeading from "./TextFieldWithHeading";
import { useState } from "react";

// NOTE: We import our "api" instance
import api from "../../config/axios";

const textFieldData = [
  { heading: "Email", placeholder: "someone@example.com", type: "email" },
  { heading: "Password", placeholder: "", type: "password" },
  { heading: "Confirm Password", placeholder: "", type: "password" },
];

function SignUpStep1({ onSuccess }) {
  // We maintain local state for email, password, confirmPassword
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // Simple handlers for each text field
  const handleEmailChange = (e) => setEmail(e.target.value);
  const handlePasswordChange = (e) => setPassword(e.target.value);
  const handleConfirmPasswordChange = (e) => setConfirmPassword(e.target.value);

  // We'll call /api/auth/register here
  const handleNextStep = async () => {
    try {
      const res = await api.post("/auth/register", {
        email,
        password,
        confirmPassword,
      });

      // If successful, we get token and user
      const { token, user } = res.data;
      // Save token in localStorage
      localStorage.setItem("token", token);

      // Then let parent (SignUpMemberCreationSection) know we finished step 1
      onSuccess();
    } catch (err) {
      console.error("Registration error:", err);
      alert(err?.response?.data?.message || "Error registering user");
    }
  };

  return (
    <MainContentReUse
      primaryText="Sign Up"
      primaryButton={{ exist: true, text: "Next Step" }}
      secondaryButton={{ exist: true, text: "Sign Up with Google" }}
      secondaryText="Register using the same browser"
      onClick={handleNextStep}
    >
      <Box sx={{ pt: "34px" }}>
        <TextFieldWithHeading
          heading="Email"
          placeholder="someone@example.com"
          type="email"
          value={email}
          onChange={handleEmailChange} // added
        />
        <TextFieldWithHeading
          heading="Password"
          placeholder=""
          type="password"
          value={password}
          onChange={handlePasswordChange} // added
        />
        <TextFieldWithHeading
          heading="Confirm Password"
          placeholder=""
          type="password"
          value={confirmPassword}
          onChange={handleConfirmPasswordChange} // added
        />
      </Box>
    </MainContentReUse>
  );
}

export default SignUpStep1;
